import Vue from 'vue'
import Vuex from 'vuex'
import Axios from "axios"
import PubNubVue from 'pubnub-vue';
import App from './App.vue'
import router from "@/_router"
import store from '@/_store';

import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/scss/_static/static.scss'
import './assets/scss/_static/ultimaker.scss'

Vue.use(Vuex);

Vue.config.productionTip = false
Vue.prototype.$http = Axios;
Vue.prototype.$pubnub = PubNubVue;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
